onReady(($) => {
    let gatedId, gatedPosts, storedFormSubmitDate, formSubmitDate;
    gatedPosts = document.querySelector('.article-container.gated-content.gated');

    if (gatedPosts) {
        const assetVisibilityInMilliSeconds = 86400000;
        const submitButton = document.querySelector('form.custom-marketo-form.gated button');
        const gatedStorage = localStorage || {
            getItem: () => '0', setItem: () => {
            },
        };

        gatedId = gatedPosts.getAttribute('data-id');
        storedFormSubmitDate = gatedStorage.getItem(`gated_form_${gatedId}`);
        formSubmitDate = new Date(parseInt(storedFormSubmitDate));

        function loadGatedTemplate() {
            gatedPosts.classList.add("show-content");
            const url = "/wp-admin/admin-ajax.php?action=load_template_part&template_part=gated-parts" + '&post_id=' + gatedId;

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        document.querySelector(".content").innerHTML = 'Something has gone wrong';
                        throw new Error('Failed to load gated content')
                    }
                    return response.json()
                })
                .then(templates => {
                    if (templates.success === false) {
                        document.querySelector(".content").innerHTML = templates.data.message;
                        return
                    }
                    const gatedDownloadFile = document.getElementById("gated-file-download");
                    if (gatedDownloadFile) {
                        gatedDownloadFile.innerHTML = templates.worksheet;
                        const fileLink = document.querySelector("#gated-file-download p a");
                        fileLink.click();
                    }
                    else {
                        document.getElementById("gated-bulletin-banner").innerHTML = templates.bulletin;
                        $('#pdf_viewer')
                            .flipBook(templates.gatedFileUrl, window.option_pdf_viewer);
                    }
                })
        }

        if (location.search.includes('typ') || (storedFormSubmitDate !== null && formSubmitDate.getTime() + assetVisibilityInMilliSeconds > Date.now())) {
            loadGatedTemplate();
        }

        submitButton.addEventListener('click', () => {
            let allFieldsValid = true;

            jQuery('.custom-marketo-form.gated input.required, .custom-marketo-form.gated  select.required')
                .each(function () {
                    if (!jQuery(this)
                        .hasClass('valid')) {
                        allFieldsValid = false;
                        return;
                    }
                });

            if (allFieldsValid === true) {
                loadGatedTemplate();
                gatedStorage.setItem('gated_form_' + gatedId, Date.now()
                    .toString());
                window.scrollTo(0, 0);
            }
        });
    }
});
